import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ShieldCheck, AlertCircle } from 'lucide-react';

/**
 * Step di setup 2FA: mostra QR code + input per il primo codice OTP.
 * Presentational component — orchestrazione e API call restano nel parent.
 */
const TwoFactorSetup = ({ qrData, secret, code, setCode, error, loading, onSubmit }) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <div className="bg-blue-50 border border-blue-200 rounded-md p-4 text-sm text-slate-700">
      <p className="font-medium mb-2 flex items-center gap-2">
        <ShieldCheck className="w-4 h-4 text-blue-600" />Come configurarlo:
      </p>
      <ol className="list-decimal list-inside space-y-1 text-xs">
        <li>Installa <strong>Google Authenticator</strong>, <strong>Authy</strong> o <strong>1Password</strong> sul telefono</li>
        <li>Apri l'app → "Aggiungi account" → "Scansiona QR code"</li>
        <li>Inquadra il QR qui sotto</li>
        <li>Inserisci il codice a 6 cifre mostrato dall'app</li>
      </ol>
    </div>

    <div className="flex flex-col items-center bg-white border rounded-md p-4">
      {qrData && <img src={qrData} alt="QR Code 2FA" className="w-48 h-48" data-testid="2fa-qr-code" />}
      <p className="text-xs text-slate-500 mt-2">Oppure inserisci manualmente:</p>
      <code className="text-xs bg-slate-100 px-2 py-1 rounded mt-1 select-all" data-testid="2fa-secret">{secret}</code>
    </div>

    {error && (
      <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
        <AlertCircle className="w-4 h-4" /> {error}
      </div>
    )}

    <div className="space-y-2">
      <Label htmlFor="code">Codice dall'app (6 cifre)</Label>
      <Input
        id="code"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        placeholder="123456"
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
        className="text-center text-xl tracking-widest"
        required
        autoFocus
        data-testid="2fa-setup-code"
      />
    </div>

    <Button
      type="submit"
      className="w-full bg-slate-900 hover:bg-slate-800"
      disabled={loading || code.length !== 6}
      data-testid="2fa-setup-confirm-btn"
    >
      {loading ? 'Verifica...' : 'Conferma e attiva 2FA'}
    </Button>
  </form>
);

export default TwoFactorSetup;
